/* eslint-disable @wordpress/dependency-group */
import $ from 'jquery';

export default function( attributes, target ) {

	const selectedAttributes = {};

	target.each(function (i, attr) {
		selectedAttributes['attribute_' + jQuery(this).attr('id')] = jQuery(this).val();
	});
	
    let selectedVariation = attributes.filter(
		attribute => JSON.stringify(attribute.attributes) === JSON.stringify(selectedAttributes)
	);
	
    return selectedVariation[0] ? selectedVariation[0] : null;

}